import React from "react"
import { styled } from "../../stitches.config";
import ReactCompareImage from 'react-compare-image';

const ImageSlider = ({ url1, url2 }) => {
    return <Wrap>
        <ReactCompareImage leftImage={url1} rightImage={url2} />
    </Wrap>
}

const Wrap = styled("div", {
    margin: "12px 0",
    "@media (min-width: 992px)": {
        "& > div": {
            minHeight: "520px"
        }
    }
});

export default ImageSlider;